import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { ELEVATEOS_LOGO_ALT } from '@/constants'

const ParkingGuestHeader = ({ buildingName }) => {
  const { t } = useTranslation(['parking'])
  return (
    <div className="parking-info__header">
      <img
        className="chitown-logo parking-info__header-logo"
        src="/images/logo/elevateos-logo-wide-black.svg"
        alt={ELEVATEOS_LOGO_ALT}
      />
      <div className="parking-info__header-title">
        {t('parking:guestHeader.title', { buildingName })}
      </div>
      <div className="parking-info__header-subtitle">{t('parking:guestHeader.subtitle')}</div>
    </div>
  )
}

ParkingGuestHeader.propTypes = {
  buildingName: PropTypes.string,
}

export default ParkingGuestHeader
